import AdaptiveCriticalImage from "../../atoms/AdaptiveCriticalImage";
import TpWidget from "../../atoms/document/TpWidget";
import RatingsUI from "@components/molecules/common/RatingsUI";
import TpWidgetMicro from "../common/TpWidgetMicro";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function Hero({ data, page }) {
  const appMode = process.env.APP_MODE;
  const signupLink = data?.cta?.href?.[appMode] || data?.cta?.href;
  return (
    <section
      className={`container grid--default hero--default lg:pb-10 md:pb-5 has-align-top`}
    >
      <article className={`lg:maxw-lg text-left`}>
        {data.hasOwnProperty("pillText") && (
          <span className={`pill fw-700 ${data.pillColorScheme}`}>
            {data.pillText}
          </span>
        )}
        <h1
          className={` lg:pt-5 lg:mw-lg ${
            data.hasOwnProperty("pillText") ? "text-lg mb-3" : "text-xl"
          }`}
          dangerouslySetInnerHTML={{
            __html: `${data.title}`,
          }}
        />
        {data.hasOwnProperty("desc") &&
          data.desc.map((item, index) => {
            return (
              <p
                className="lg:maxw-md lg:mt-2 lg:mb-2"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          })}
        {data.hasOwnProperty("cta") && (
          <div className="lg:mt-5 md:mt-3">
            <a href={signupLink} className="btn-primary md:w-100">
              <span>{data.cta.text}</span>
            </a>
          </div>
        )}
        {data.hasOwnProperty("hasTpWidget") && (
          <>
            <TpWidgetMicro
              className={`lg:mt-5 md:mt-3 md:pt-2 ${
                data.hasOwnProperty("cta") ? "" : "md:ml-0"
              }`}
            />
          </>
        )}
        {data.hasOwnProperty("ratings") && (
          <RatingsUI data={data.ratings} className="lg:mt-5 md:mb-3" />
        )}
      </article>{" "}
      <figure className="layered-images-wrap pos-rel lg:maxw-lg md:mt-5">
        <picture
          dangerouslySetInnerHTML={{
            __html: data.images.bg.src,
          }}
        />
        <picture>
          <AdaptiveCriticalImage
            src={data.images.fg.src}
            alt={data.images.fg.alt}
            mobile={data.images.fg.prefixes.mobile}
            dpi={data.images.fg.prefixes.dpi}
            dimensions={data.images.fg.dimensions}
            className="fg-layer"
          />
        </picture>
      </figure>
      <style jsx>{`
        @media (max-width: ${viewport.desktop.sm}) {
          figure :global(img) {
            width: 100%;
            height: auto;
          }
        }
        @media (min-width: ${viewport.tablet.sm}) {
          figure :global(.fg-layer) {
            ${page === "tour-booking-software"
              ? `
            width:145%;
            left: -105px
            `
              : ``}
          }
        }
        .pill {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          padding: 7px 12px;
          border-radius: 16px;
          font-size: ${font.size.sm[1]};
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        .pill.green {
          color: ${colors.primitive.green[400]};
          background-color: ${colors.primitive.green[500]};
        }
        .pill.violet {
          color: ${colors.primitive.violet[300]};
          background-color: ${colors.primitive.violet[400]};
        }
        .pill.yellow {
          color: ${colors.primitive.yellow.default};
          background-color: ${colors.primitive.yellow[200]};
        }
        .pill.blue {
          color: ${colors.primitive.blue[50]};
          background-color: ${colors.primitive.blue[30]};
        }
        .pill.light-blue {
          color: ${colors.primitive.blue[500]};
          background-color: ${colors.primitive.blue[400]};
        }
        .pill.orange {
          color: ${colors.primitive.orange[200]};
          background-color: ${colors.primitive.orange[100]};
        }
        @media (max-width: ${viewport.mobile.md}) {
          .pill {
            position: absolute;
            top: -50px;
          }
        }
        ${data.hasOwnProperty("pillText")
          ? `
            .hero--default article {
              position: relative;
            }
            .hero--default {
              padding-top: 72px;
              padding-bottom: 80px !important;
            }
          @media (min-width: ${viewport.desktop.sm}) {
            .hero--default article {
              position: relative;
              top: -64px;
            }
            .hero--default {
              padding-top: 140px;
            }
          }
        `
          : ``}
      `}</style>
    </section>
  );
}
